import * as React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";


const FAQSection = () => {
    const { t } = useTranslation();
    const faqCount = 9; // total number of FAQs
    const accordions = [];

    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    for (let i = 1; i <= faqCount; i++) {
        const key = `q${i}`;
        accordions.push(
            <Accordion expanded={expanded === ('panel' + i)} onChange={handleChange('panel' + i)} defaultExpanded={i == 1 ? true : false} size="large"
                sx={{
                    mb: i < faqCount ? 2 : 0,
                    py: 1,
                    px: 1,
                    border: "none",
                    backgroundColor: "transparent"
                }
                } key={key} >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h5" fontSize={{ xs: "1.2em", sm: "1.4em" }} sx={{ fontWeight: "500", maxWidth: { xs: "90%", sm: "100%" } }} textAlign={"left"} color="primary">
                        {i}. {t(`faq.${key}.question`)}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography sx={{ textAlign: "left", maxWidth: { xs: "90%", sm: "100%" } }} color="primary">
                        {t(`faq.${key}.answer`)}
                    </Typography>
                </AccordionDetails>
            </Accordion >
        );
    }

    return (
        <Box sx={{ maxWidth: 800, mx: "auto", mt: { xs: 6, sm: 12 }, mb: { xs: 1, sm: 6 }, textAlign: "center" }}>
            {/* Headline */}
            <Typography color="primary" variant="h2" mb={{ xs: 2, sm: 8 }}>
                {t("faq.title")}
            </Typography>

            {accordions}
        </Box>
    );
};

export default FAQSection;
